import "./style.css";

interface RadioButtonProps {
  label?: string;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioButton = ({ label, value, checked, onChange }: RadioButtonProps) => {
  
  return (
    <div className="radio-wrapper">
      <label className="custom-radio">
        <input
          type="checkbox"
          name="opcao"
          value={value}
          checked={checked}
          onChange={onChange}
        />
        <span className="radio-circle"></span>
        {label}
      </label>
    </div>
  );
};

export default RadioButton;
